import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { BannerComponent } from './banner/banner.component';
import { SeoTextComponent } from './seo-text/seo-text.component';

@NgModule({
  declarations: [FooterComponent, HeaderComponent, BannerComponent, SeoTextComponent],
  imports: [CommonModule],
  exports: [HeaderComponent, FooterComponent, BannerComponent, SeoTextComponent]
})
export class LayoutModule {}
